import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const UnityServe = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsUnity" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/UnityServe/UnityServe.mp4" type="video/mp4" />
                                </video>
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/UnityServe/Vision.png" className="d-block w-100" alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/UnityServe/Sell.png" className="d-block w-100 " alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/UnityServe/Products.png" className="d-block w-100" alt="..." />
                            </div>
                            <div className="carousel-item ">
                                <img src="../IMG/UnityServe/ProductPage.png" className="d-block w-100" alt="..." />
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="Unity" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">UnityServe</p>
                            <p className="Project--info--subheading">FullStack Web Development</p>
                            <p className="Project--info--subheading">Using MERN Stack</p>
                            <p className="Project--info--Para">College made Easy with our All-in-one campus Marketplace
                                - Buy, Sell,
                                Rent, Donate, and fulfill product requests Effortlessly</p>
                            <p className="Project--info--Para">Empowering college students with a campus-centric online
                                marketplace
                                to buy, rent, and request products, fostering affordability, sustainability, and
                                community
                                collaboration.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/JAMSHACK23_UnityServe" target='__blank'>Github</a>
                            <a href="https://devfolio.co/projects/unityserve-03ce" target='__blank'>DevFolio</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>MongoDB</p>
                            <p>Express.js</p>
                            <p>React.js</p>
                            <p>Node.js</p>
                            <p>Html/Css </p>
                            <p>Javascript</p>
                            <p>Bootstrap</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnityServe